import {AbstractWidget} from "../utils/AbstractWidget"
import WizardResultPage from "../components/climatWizardResult/WizardresultPage";

export default class WizardResult extends AbstractWidget {
  get UIComponent() {
    return WizardResultPage;
  }
}